import { render, staticRenderFns } from "./MedicalPaymentInputForm.vue?vue&type=template&id=1386cc55&scoped=true&"
import script from "./MedicalPaymentInputForm.vue?vue&type=script&lang=js&"
export * from "./MedicalPaymentInputForm.vue?vue&type=script&lang=js&"
import style0 from "./MedicalPaymentInputForm.vue?vue&type=style&index=0&id=1386cc55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386cc55",
  null
  
)

export default component.exports